// Angular Imports
// =========================================================
import { Component, type OnDestroy, type OnInit } from '@angular/core'
import { type ILoadingOverlayAngularComp } from 'ag-grid-angular'
import { AgPromise, ILoadingOverlayComp, type ILoadingOverlayParams } from 'ag-grid-community'
// Angular Material Imports
// =========================================================
// Prime NG Imports
// =========================================================
// Custom Imports
// =========================================================
// JSON Data
// =========================================================

@Component({
  standalone: false,
  selector: 'app-reco-buy-qty-grid-overlay',
  templateUrl: './reco-buy-qty-grid-overlay.component.html',
  styleUrls: ['./reco-buy-qty-grid-overlay.component.scss']
})
export class RecoBuyQtyGridOverlayComponent implements ILoadingOverlayAngularComp {
  params: any = {} // ILoadingOverlayParams<any, any>
  constructor () {}

  agInit (params: ILoadingOverlayParams<any, any>): void {
    console.log('overlay component params', params)
    this.params = params
  }

  refresh? (params: ILoadingOverlayParams<any, any>): void {}
}
